module.exports = __webpack_public_path__ + "img/21-l.da5019a2.png";